import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20retail%20display%20with%20neutral%20linen%20clothing%20on%20minimalist%20wooden%20racks%2C%20warm%20cream%20and%20sage%20green%20color%20palette%2C%20soft%20diffused%20lighting%2C%20Scandinavian%20boutique%20interior%2C%20clean%20atmosphere%2C%20editorial%20photography%2C%20peaceful%20shopping%20experience&width=1600&height=700&seq=cta-new-img-p4&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/85 to-background-50/70"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
          Gotowy, aby zacząć?
        </span>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
          Odkryj pełny potencjał USFansSpreadsheet już dziś
        </h2>
        <p className="text-foreground-600 leading-relaxed mb-8 md:mb-10 max-w-[550px] mx-auto">
          Nie czekaj – dołącz do tysięcy zadowolonych użytkowników i przekonaj się, 
          jak USFansSpreadsheet może usprawnić Twoją pracę z arkuszami kalkulacyjnymi.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg text-sm md:text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-cart-line mr-2"></i>
            Buy It Now
          </a>
          <Link
            to="/artykul/kompletny-przewodnik-usfansspreadsheet-2026"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg text-sm md:text-base font-semibold bg-background-50 text-foreground-950 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>
            Przeczytaj przewodnik
          </Link>
        </div>
      </div>
    </section>
  );
}